import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type OrderFinancialStatusEventPayloadFragment = (
  { readonly __typename?: 'OrderFinancialStatusEvent' }
  & Pick<TP.OrderFinancialStatusEvent, 'id' | 'financialStatus' | 'type'>
);

export const OrderFinancialStatusEventPayloadFragmentDoc = gql`
    fragment OrderFinancialStatusEventPayload on OrderFinancialStatusEvent {
  id
  financialStatus
  type
}
    `;